const projectData = [
  {
    id: 1,
    createdAt: "2024-09-16T12:25:16+0000",
    ref: ["fullStack", "react", "node", "expressjs", "mongodb"],
    img: "images/projectPics/jobs-portal.png",
    title: "Job Portal",
    tags: [
      "ExpressJs",
      "MongoDB",
      "rest-api",
      "CRUD operations",
      "Mongoose",
      "NodeJS",
      "XSS protection",
      "Content-Security-Policy (CSP)",
      "Authentication",
      "Pagination",
      "Frontend",
      "Backend",
      "Object-oriented programming (OOP)",
      "redux",
      "redux-toolkit",
      "createPortal",
      "react-slider",
      "navigate ",
      "params",
      "children",
      "eslint",
      "javaScript XML",
      "mapping",
      "filtering",
      "virtual DOM",
      "react-router-dom",
      "state management",
      "props",
      "javascript",
      "custom-events",
      "Animation",
      "gsap",
      "bootstrap",
      "react",
      "destructuring",
      "ES6",
      "scss",
      "useState",
      "lifecycle-hooks",
      "list-filter",
      "functional programming",
      "components",
      "useEffect",
      "DOM",
    ],
    description:
      "Job Board is a job search and recruitment platform designed to streamline the hiring process. Employers can easily post jobs, and job seekers can browse and apply for opportunities. Key features include job posting and management for employers, a job search with filters for location and job type, and secure user registration for managing profiles and applications. Both employers and candidates have personalized dashboards for tracking job postings and applications. The platform is mobile-friendly, ensuring a smooth experience across devices.",
    code: "https://github.com/Ranjeet2311/Job_board",
    demo: "https://job-board-obu5.onrender.com/",
  },
  {
    id: 2,
    createdAt: "2025-01-21T12:25:16+0000",
    ref: ["fullStack", "react", "node", "expressjs", "mongodb", "typescript"],
    img: "images/projectPics/kumar-software.png",
    title: "Kumar Software | NextJs",
    tags: [
      "typeScript",
      "NextJs",
      "JWT",
      "rest-api",
      "Authentication",
      "Forms",
      "redux-toolkit",
      "redux",
      "createPortal",
      "children",
      "eslint",
      "javaScript XML",
      "mapping",
      "find()",
      "findIndex",
      "virtual DOM",
      "react-router-dom",
      "state management",
      "props",
      "javascript",
      "custom-events",
      "bootstrap",
      "react",
      "destructuring",
      "ES6",
      "scss",
      "useState",
      "lifecycle-hooks",
      "list-filter",
      "functional programming",
      "components",
      "useEffect",
      "DOM",
    ],
    description:
      "! UNDER CONSTRUCTION ! Kumar Softwares is a company specializing in creating dynamic websites and robust web applications tailored to enhance your brand's digital presence. ",
    code: "https://github.com/Ranjeet2311/kumar_software",
    demo: "https://kumar-software.netlify.app/",
  },
  {
    id: 3,
    createdAt: "2024-02-16T12:25:16+0000",
    ref: ["vue", "fullStack", "firebase"],
    img: "images/projectPics/music-app.png",
    title: "Music Wallets",
    tags: [
      "vue3",
      "authentication",
      "Storage",
      "CRUD operations",
      "firebase",
      "javascript",
      "firestore",
      "firebase-authentication",
      "scss",
      "route-guards",
      "Html",
      "vue-components",
      "vue-router",
      "bootstrap5",
      "composition-api",
      "crud-operation",
    ],
    description:
      "The app at Music-at-Tips is hosted at firebase, it's a web-based platform designed for music enthusiasts and professionals. It allows users to explore, share, and discover music tips and techniques. The app features a clean and intuitive user interface that supports easy navigation and offers various functionalities for enhancing musical knowledge and skills. The login feature ensures a personalized experience, allowing users to access and manage their profiles, saved content, and customized settings.",
    code: "https://github.com/Ranjeet2311/Music-Wallets",
    demo: "https://music-at-tips.web.app/login",
  },
  {
    id: 4,
    createdAt: "2024-07-26T12:25:16+0000",
    ref: ["react"],
    img: "images/projectPics/Portfolio.png",
    title: "Portfolio | React",
    tags: [
      "redux",
      "redux-toolkit",
      "createPortal",
      "children",
      "eslint",
      "javaScript XML",
      "mapping",
      "filtering",
      "virtual DOM",
      "react-router-dom",
      "state management",
      "props",
      "javascript",
      "custom-events",
      "material-Ui",
      "material-Icons",
      "Animation",
      "gsap",
      "bootstrap",
      "react",
      "destructuring",
      "ES6",
      "scss",
      "useState",
      "lifecycle-hooks",
      "list-filter",
      "functional programming",
      "components",
      "useEffect",
      "DOM",
    ],
    description:
      "This web app serves as a professional portfolio, showcasing a collection of coding projects and technical expertise. It features a clean, user-friendly design that highlights various repositories with descriptions, tags, and direct links to both the source code and live demos. The app demonstrates proficiency in technologies like React, Vue, and Angular, making it an effective tool for presenting the developer's capabilities to potential employers or collaborators.",
    code: "https://github.com/Ranjeet2311/upgraded",
    demo: "https://ranjeet2311.github.io/upgraded/",
  },

  {
    id: 5,
    createdAt: "2024-08-26T12:25:16+0000",
    ref: ["react", "typescript"],
    img: "images/projectPics/restaurant-app.png",
    title: "Restaurant | TS | Redux",
    tags: [
      "typeScript",
      "redux-toolkit",
      "redux",
      "createPortal",
      "children",
      "eslint",
      "javaScript XML",
      "mapping",
      "find()",
      "findIndex",
      "virtual DOM",
      "react-router-dom",
      "state management",
      "props",
      "javascript",
      "custom-events",
      "bootstrap",
      "react",
      "destructuring",
      "ES6",
      "scss",
      "useState",
      "lifecycle-hooks",
      "list-filter",
      "functional programming",
      "components",
      "useEffect",
      "DOM",
    ],
    description:
      "This app is a modern restaurant management platform designed to streamline the process of ordering and managing food items online. It features an intuitive user interface where customers can browse through a variety of menu items, add their selections to the cart, and place orders efficiently. The app also integrates various functionalities like filtering food categories, displaying detailed product information, and managing orders, making it an ideal solution for restaurants looking to enhance their online presence and improve customer service.",
    code: "https://github.com/Ranjeet2311/restaurant-app",
    demo: "https://spontaneous-horse-117d2d.netlify.app",
  },
  {
    id: 6,
    createdAt: "2024-09-03T12:25:16+0000",
    ref: ["fullStack", "react", "sql", "node"],
    img: "images/projectPics/NextLevel-Food-menu.png",
    title: "Recipe-share | NextJs",
    tags: [
      "Sql",
      "slugify",
      "eslint",
      "CRUD operations",
      "xss-protection",
      "react-dom",
      "bootstrap",
      "children",
      "SCSS",
      "javaScript XML",
      "mapping",
      "virtual DOM",
      "react-router-dom",
      "state management",
      "props",
      "javascript",
      "custom-events",
      "NextJs",
      "destructuring",
      "ES6",
      "scss",
      "useState",
      "lifecycle-hooks",
      "functional programming",
      "components",
      "DOM",
    ],
    description:
      "The app at is a recipe-sharing platform. It allows users to explore a collection of recipes, which are likely displayed with details such as ingredients, preparation steps, and possibly images. The design appears to focus on user-friendly navigation, enabling users to browse through different meals and find recipes easily. The platform is likely built using modern web technologies, with the potential for features like search functionality, categorization, and user interaction (e.g., comments or ratings).",
    code: "https://github.com/Ranjeet2311/recipe-_sharing",
    demo: "https://recipe-sharing-kxw9.onrender.com/",
  },
  {
    id: 7,
    createdAt: "2023-12-20T12:25:16+0000",
    ref: ["vue", "fullStack", "firebase"],
    img: "images/projectPics/chat-app.png",
    title: "Friends Chat",
    tags: [
      "authentication",
      "CRUD operations",
      "Storage",
      "firebase",
      "bootstrap5",
      "composition-api",
      "Vue-router",
      "composables",
      "authentication",
      "vue-components",
      "vue3",
      "firestore",
      "firebase-authentication",
      "crud-operation",
      "vue-composable",
      "javascript",
      "Storage",
      "scss",
      "Html",
    ],
    description:
      "The app hosted at firebase, Group Chat is a streamlined, web-based communication platform designed for real-time group messaging. The application is built to facilitate seamless conversations within groups, offering users an intuitive interface where they can join discussions, share messages, and stay connected with peers in a collaborative environment.Key features include the ability to create and join different chat rooms, where users can exchange messages instantly. The app supports a responsive design, ensuring it works smoothly across various devices, from desktops to mobile phones. Users can expect a straightforward login process, followed by access to chat rooms where messages are displayed in a clear and organized thread.The app is ideal for teams, communities, or social groups looking for a reliable and user-friendly tool for communication. The minimalist design focuses on usability, ensuring that the primary function—group communication—is executed efficiently without unnecessary distractions.",
    code: "https://github.com/Ranjeet2311/group-chat",
    demo: "https://group-chat-2.netlify.app/",
  },
  {
    id: 8,
    createdAt: "2024-03-03T12:25:16+0000",
    ref: ["angular", "typescript"],
    img: "images/projectPics/git-app.png",
    title: "Github Repo browser",
    tags: [
      "typescript",
      "rxjs",
      "reactive-form",
      "observables",
      "Graphql",
      "html",
      "angular",
      "rxjs",
      "interface",
      "mapping",
      "scss",
      "http-client",
      "lifecycle",
      "angular-router",
      "dynamic-routing ",
      "scss",
      "reactiveformsmodule",
      "reactiveform-validation",
      "list-filter",
    ],
    description:
      "Use you github token to run this app, The app at Gith is a streamlined tool designed for developers and tech enthusiasts to efficiently search, filter, and explore GitHub repositories. It provides a user-friendly interface that allows for quick access to repository details such as stars, forks, and recent updates, making it easier to find relevant projects for contribution or learning. With its responsive design, 'Gith' ensures a consistent experience across all devices, making it a practical resource for anyone looking to navigate GitHub’s vast repository ecosystem.",
    code: "https://github.com/Ranjeet2311/GIthub-Repo-browser",
    demo: "https://gith.netlify.app/",
  },
  {
    id: 9,
    createdAt: "2024-03-27T12:25:16+0000",
    ref: ["angular", "typescript"],
    img: "images/projectPics/Appointment-App.png",
    title: "Appointment tracker",
    tags: [
      "lifecycle",
      "browser-memory",
      "html",
      "angular",
      "typescript",
      "interface",
      "mapping",
      "scss",
      "http-client",
      "angular-router",
      "scss",
      "list-filter",
    ],
    description:
      "The app allows users to monitor the status of their tasks in real-time, providing a clear overview of ongoing, pending, and completed tasks.Task Creation and Management: Users can easily create new tasks, assign due dates, and set priorities to ensure that the most critical tasks are addressed first. The design is clean and intuitive, making it easy for users of all skill levels to navigate and utilize the app's features without a steep learning curve.",
    code: "https://github.com/Ranjeet2311/Personal-appointment-booking",
    demo: "https://tracker01.netlify.app/",
  },

  // {
  //   id: 9,
  //   createdAt: "2021-08-10T12:25:16+0000",
  //   ref: ["react"],
  //   img: "images/projectPics/quiz-demo.jpg",
  //   title: "Quiz App (React)",
  //   tags: [
  //     "eslint",
  //     "JavaScript XML",
  //     "Virtual DOM",
  //     "state management",
  //     "Props",
  //     "mapping",
  //     "javascript",
  //     "react",
  //     "Destructuring",
  //     "ES6",
  //     "scss",
  //     "useState",
  //     "lifecycle-hooks",
  //     "list-filter",
  //     "functional programming",
  //     "components",
  //     "useEffect",
  //     "mapping",
  //     "DOM",
  //   ],
  //   description:
  //     "The app hosted at Quiz App is an interactive platform designed for creating, taking, and sharing quizzes. It provides users with a seamless experience to test their knowledge on various topics, offering immediate feedback on their performance. The app's intuitive interface makes it easy to navigate through questions, and its responsive design ensures accessibility across different devices. Whether for educational purposes or entertainment, this app is ideal for both casual users and educators looking to engage their audience through quizzes.",
  //   code: "https://github.com/Ranjeet2311/React-Quiz-App",
  //   demo: "https://quiz-app-0810.netlify.app/",
  // },
  {
    id: 10,
    createdAt: "2021-09-02T12:25:16+0000",
    ref: ["react"],
    img: "images/projectPics/Text-to-speech-image.jpg",
    title: "React-Text to Speech",
    tags: [
      "state management",
      "eslint",
      "Props",
      "JavaScript XML",
      "Array",
      "Objects",
      "Virtual DOM",
      "react",
      "javascript",
      "scss",
      "lifecycle-hooks",
      "components",
      "useEffect",
      "scss",
      "list-filter",
      "functional programming",
      "mapping",
      "DOM",
      "Destructuring",
      "ES6",
    ],
    description:
      "The app is a speech-to-text tool that converts spoken words into written text. It uses voice recognition technology to transcribe audio in real time, making it easier to create text documents, take notes, or dictate messages without typing. It’s a useful tool for those who need to quickly capture spoken content or for accessibility purposes.",
    code: "https://github.com/Ranjeet2311/React-Speech-to-text",
    demo: "https://speech-to-text-09-01.netlify.app",
  },
  {
    id: 11,
    createdAt: "2022-03-02T12:25:16+0000",
    ref: ["vue"],
    img: "images/projectPics/counter-app.png",
    title: "Simple Counter",
    tags: [
      "methods",
      "vue-components",
      "state management",
      "scss",
      "Html",
      "data",
      "vue2",
      "JavaScript",
      "vue-router",
    ],
    description:
      "It is just a simple counter app made in Vue Framework with up, down and reset button. This app does not save any data to browser memory.",
    code: "https://github.com/Ranjeet2311/Vue-Counter",
    demo: "https://dulcet-quokka-b7e591.netlify.app/",
  },
  // {
  //   id: 12,
  //   createdAt: "2022-02-11T12:25:16+0000",
  //   ref: ["react"],
  //   img: "images/projectPics/KeeperApp.png",
  //   title: "Keeper App (React)",
  //   tags: [
  //     "lifecycle-hooks",
  //     "Destructuring",
  //     "Material-Ui",
  //     "state management",
  //     "eslint",
  //     "Props",
  //     "filter",
  //     "JavaScript XML",
  //     "Virtual DOM",
  //     "Array",
  //     "Objects",
  //     "react",
  //     "javascript",
  //     "scss",
  //     "components",
  //     "useEffect",
  //     "scss",
  //     "list-filter",
  //     "functional programming",
  //     "mapping",
  //     "DOM",
  //     "Destructuring",
  //     "ES6",
  //   ],
  //   description:
  //     "This app was inspired by keeper app of google. It lets you create and delete any items in the keeper app.  This app does not save any data to browser memory.",
  //   code: "https://github.com/Ranjeet2311/Keeper-App",
  //   demo: "https://keeper-01.netlify.app/",
  // },
  // {
  //   id: 13,
  //   createdAt: "2021-12-15T12:25:16+0000",
  //   ref: ["react"],
  //   img: "images/projectPics/movie-database-project.png",
  //   title: "Movie Database (React)",
  //   tags: [
  //     "axios",
  //     "eslint",
  //     "state management",
  //     "lifecycle-hooks",
  //     "Props",
  //     "filter",
  //     "Array",
  //     "Objects",
  //     "JavaScript XML",
  //     "Virtual DOM",
  //     "react",
  //     "javascript",
  //     "scss",
  //     "components",
  //     "useEffect",
  //     "scss",
  //     "list-filter",
  //     "functional programming",
  //     "mapping",
  //     "DOM",
  //     "Destructuring",
  //     "ES6",
  //   ],
  //   description:
  //     "The app is a movie database that allows users to browse and search for information about various films. It provides details such as movie titles and more. Users can explore a range of movies, making it a handy tool for discovering new films or finding information about their favorites.",
  //   code: "https://github.com/Ranjeet2311/React-MovieDatabase-app",
  //   demo: "https://movie-database-project-0802.netlify.app/",
  // },
  // {
  //   id: 14,
  //   createdAt: "2022-03-02T12:25:16+0000",
  //   ref: ["react"],
  //   img: "images/projectPics/contact-manager.jpg",
  //   title: "Contact Manager (React)",
  //   tags: [
  //     "Material-Ui",
  //     "eslint",
  //     "JavaScript XML",
  //     "Array",
  //     "filter",
  //     "Objects",
  //     "Props",
  //     "state management",
  //     "lifecycle-hooks",
  //     "Virtual DOM",
  //     "react",
  //     "javascript",
  //     "scss",
  //     "components",
  //     "useEffect",
  //     "scss",
  //     "list-filter",
  //     "functional programming",
  //     "mapping",
  //     "DOM",
  //     "Destructuring",
  //     "ES6",
  //   ],
  //   description:
  //     "This app was inspired by contact manager apps. It lets you create and delete contacts. This app does not save any data to browser memory.",
  //   code: "https://github.com/Ranjeet2311/React-Contact-Mangaer",
  //   demo: "https://contact-manager-001.netlify.app/",
  // },

  // {
  //   id: 12,
  //   createdAt: "2021-10-12T12:25:16+0000",
  //   ref: "react",
  //   img: "images/projectPics/drone-comapny.jpg",
  //   title: "Drone Company (React)",
  //   tags: [
  //     "react-dom",
  //     "react-router-dom",
  //     "eslint",
  //     "JavaScript XML",
  //     "Props",
  //     "animations",
  //     "state management",
  //     "lifecycle-hooks",
  //     "filter",
  //     "Virtual DOM",
  //     "react",
  //     "javascript",
  //     "scss",
  //     "child components",
  //     "useEffect",
  //     "functional programming",
  //     "DOM",
  //     "Destructuring",
  //     "ES6",
  //   ],
  //   description:
  //     "A simple single page application (SPA). with minimal hand-written animation",
  //   code: "https://github.com/Ranjeet2311/React--Sass-Website",
  //   demo: "https://drone-comapny.netlify.app/",
  // },
  // {
  //   id: 13,
  //   createdAt: "2021-06-13T12:25:16+0000",
  //   ref: "react",
  //   img: "images/projectPics/React-home.png",
  //   title: "React-Website (React)",
  //   tags: [
  //     "Material-Ui",
  //     "eslint",
  //     "react-dom",
  //     "react-router-dom",
  //     "JavaScript XML",
  //     "Array",
  //     "filter",
  //     "Objects",
  //     "Props",
  //     "state management",
  //     "lifecycle-hooks",
  //     "Virtual DOM",
  //     "react",
  //     "javascript",
  //     "scss",
  //     "components",
  //     "useEffect",
  //     "scss",
  //     "list-filter",
  //     "functional programming",
  //     "mapping",
  //     "DOM",
  //     "Destructuring",
  //     "ES6",
  //   ],
  //   description:
  //     "A simple single page application (SPA). with minimal hand-written animation",
  //   code: "https://github.com/Ranjeet2311/React-Website",
  //   demo: "https://react-website-0803.netlify.app/",
  // },
  // {
  //   id: 13,
  //   createdAt: "2021-06-21T12:25:16+0000",
  //   ref: "react",
  //   img: "images/projectPics/react-menu-home.png",
  //   title: "React Dynamic Menu (React)",
  //   tags: [
  //     "react-dom",
  //     "react-router-dom",
  //     "eslint",
  //     "JavaScript XML",
  //     "Props",
  //     "animations",
  //     "state management",
  //     "lifecycle-hooks",
  //     "filter",
  //     "Virtual DOM",
  //     "react",
  //     "javascript",
  //     "scss",
  //     "child components",
  //     "useEffect",
  //     "functional programming",
  //     "DOM",
  //     "Destructuring",
  //     "ES6",
  //   ],
  //   description:
  //     "A simple single page application (SPA). with minimal hand-written animation",
  //   code: "https://github.com/Ranjeet2311/React-Navbar",
  //   demo: "https://react-navigation-menu-0803.netlify.app/",
  // },

  // {
  //   id: 14,
  //   ref: "funApp",
  //   img: "images/projectPics/to-do-tasks.jpg",
  //   title: " To-do-app",
  //   description:
  //     "Just a fun todo app, allows you to create, delete and mark completed tasks. This app does not save any data to browser memory.",
  //   code: "https://github.com/Ranjeet2311/To-Do-App-Vanilla-JS",
  //   demo: "https://old-portfolio0.netlify.app/app-demo/todo.html",
  // },
  // {
  //   id: 15,
  //   ref: "funApp",
  //   img: "images/projectPics/Weather.jpg",
  //   title: "Weathe App",
  //   description:
  //     "Just a fun todo app, allows you to check wethaer of any correct entered location. This app does not save any data to browser memory.",
  //   code: "https://github.com/Ranjeet2311/Weather-App",
  //   demo: "https://old-portfolio0.netlify.app/app-demo/weather.html",
  // },

  // {
  //   id: 16,
  //   ref: "funApp",
  //   img: "images/projectPics/qr-code-bg.jpg",
  //   title: " QR-Code Generator",
  //   description:
  //     "Enables you to crerate QR code for any text or URL you need. Take a screenshot or QR code and use it wherever you need it. This app does not save any data to browser memory.",
  //   code: "https://github.com/Ranjeet2311/Qr-Code-Generator",
  //   demo: "https://qr-code-25-11.netlify.app/",
  // },
  // {
  //   id: 17,
  //   ref: "funApp",
  //   img: "images/projectPics/Personality-match.jpg",
  //   title: "Personality Match",
  //   code: "https://github.com/Ranjeet2311/Personality-Match",
  //   demo: "https://personality-match.netlify.app/",
  // },

  // {
  //   id: 18,
  //   ref: "funApp",
  //   img: "images/projectPics/weight-converter.jpg",
  //   title: " Weight converter",
  //   code: "https://github.com/Ranjeet2311/Weight-Converter",
  //   demo: "https://old-portfolio0.netlify.app/app-demo/weight-converter.html",
  // },

  // {
  //   id: 19,
  //   ref: "funApp",
  //   img: "images/projectPics/music-player.jpg",
  //   title: "Music player",
  //   code: "https://github.com/Ranjeet2311/Music-player",
  //   demo: "https://old-portfolio0.netlify.app/app-demo/music-player.html",
  // },

  // {
  //   id: 20,
  //   ref: "funApp",
  //   img: "images/projectPics/counter.jpg",
  //   title: "Counter",
  //   code: "https://github.com/Ranjeet2311/Counter-",
  //   demo: "https://old-portfolio0.netlify.app/app-demo/counter.html",
  // },

  // {
  //   id: 21,
  //   ref: "funApp",
  //   img: "images/projectPics/Digital-Clock.jpg",
  //   title: " Digital clock",
  //   code: "https://github.com/Ranjeet2311/Digital-Clock",
  //   demo: "https://old-portfolio0.netlify.app/app-demo/digital-clock.html",
  // },

  // {
  //   id: 22,
  //   ref: "funApp",
  //   img: "images/projectPics/play-music.jpg",
  //   title: "Tap the music",
  //   code: "https://github.com/Ranjeet2311/Tap-the-Music",
  //   demo: "https://old-portfolio0.netlify.app/app-demo/play-music.html",
  // },

  // {
  //   id: 23,
  //   ref: "funApp",
  //   img: "images/projectPics/Menu-display.jpg",
  //   title: "Menu display -filter",
  //   code: "https://github.com/Ranjeet2311/Dynamic-Menu-Display",
  //   demo: "https://old-portfolio0.netlify.app/app-demo/menu-display.html",
  // },

  // {
  //   id: 24,
  //   ref: "funApp",
  //   img: "images/projectPics/modal.jpg",
  //   title: "Best pictures from Europe",
  //   code: "https://github.com/Ranjeet2311/Modal",
  //   demo: "https://old-portfolio0.netlify.app/app-demo/modal.html",
  // },
  // {
  //   id: 25,
  //   ref: "funApp",
  //   img: "images/projectPics/diceGame.png",
  //   title: "Dice Game",
  //   code: "https://github.com/Ranjeet2311/Dice-Game",
  //   demo: "https://dazzling-heisenberg-3851ef.netlify.app/",
  // },
  // {
  //   id: 26,
  //   ref: "template",
  //   img: "images/projectPics/Av-st-Template-demo.PNG",
  //   title: "Av-st-Template",
  //   code: "https://github.com/Ranjeet2311/frontend-_AV",
  //   demo: "https://av-st-template.netlify.app/",
  // },
  // {
  //   id: 27,
  //   ref: "template",
  //   img: "images/projectPics/form-validation-e.jpg",
  //   title: "Form validation",
  //   code: "https://github.com/Ranjeet2311/Parcel-bundler",
  //   demo: "https://render-007.netlify.app/",
  // },
  // {
  //   id: 28,
  //   ref: "template",
  //   img: "images/projectPics/yoga-demo.png",
  //   title: "Yoga-demo",
  //   code: "https://github.com/Ranjeet2311/Projects",
  //   demo: "https://old-portfolio0.netlify.app/app-demo/yoga-demo.html",
  // },
  // {
  //   id: 29,
  //   ref: "template",
  //   img: "images/projectPics/tech-demo.jpg",
  //   title: "Tech-demo",
  //   code: "https://github.com/Ranjeet2311/Projects",
  //   demo: "https://old-portfolio0.netlify.app/app-demo/tech-demo.html",
  // },
  // {
  //   id: 30,
  //   ref: "template",
  //   img: "images/projectPics/car-service-demo.png",
  //   title: "Car service demo",
  //   code: "https://github.com/Ranjeet2311/Projects",
  //   demo: "https://old-portfolio0.netlify.app/app-demo/car-service.html",
  // },
  // {
  //   id: 31,
  //   ref: 'template',
  //   img: 'images/projectPics/game-sign-up.png',
  //   title: 'Game-sign-up',
  //   code: 'https://github.com/Ranjeet2311/Projects',
  //   demo: 'https://old-portfolio0.netlify.app/app-demo/hero-page.html',
  // },
  // {
  //   id: 32,
  //   ref: 'template',
  //   img: 'images/projectPics/my-portfolio.png',
  //   title: 'Old portfolio',
  //   code: 'https://github.com/Ranjeet2311/Ranjeet2311.github.io',
  //   demo: 'https://old-portfolio0.netlify.app/',
  // },
  // {
  //   id: 33,
  //   ref: "template",
  //   img: "images/projectPics/Animated-Boat.jpg",
  //   title: "Animated Boat",
  //   code: "https://github.com/Ranjeet2311/Boat-Animation",
  //   demo: "https://old-portfolio0.netlify.app/app-demo/animatedBoat.html",
  // },

  // {
  //   id: 34,
  //   ref: 'template',
  //   img: 'images/projectPics/e-commerce-demo.png',
  //   title: 'E-commerce-demo',
  //   code: 'https://github.com/Ranjeet2311/Projects',
  //   demo: 'https://old-portfolio0.netlify.app/app-demo/e-commerce-demo.html',
  // },

  // {
  //   id: 35,
  //   ref: 'angular',
  //   img: 'images/projectPics/angular-todo.png',
  //   title: 'Todo-Angular',
  //   code: 'https://github.com/Ranjeet2311/Todo-Angular',
  //   demo: 'https://adorable-phoenix-646f30.netlify.app/',
  // },
];

export default projectData;
